/**
 * Flexible Post Tabs
 *
 * Used by flexible-layouts/flexible-post-tabs
 */

import $ from 'jquery';

export const postTabs = () => {

    $.get( 'wp-json/wp/v2/service', function( data ) {
        
        console.log( data[0] );

        data.forEach( function( currentValue, index, dataNode ) {
        
            console.log(currentValue.title.rendered);

        } );

    } );

};

